import { getRequest } from '../services/requestHandler';
import { HeadWeightLocationLookup } from '../models';

export const getHeadWeightLocationLookups = async () => {
  const url = 'headWeight/getHeadWeightLocationLookups?activeOnly=true&useCache=false';
  const response = await getRequest<HeadWeightLocationLookup>('GetHeadWeightLocationLookups', url);
  return response;
};
